var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Service',{attrs:{"color":"green"}},[_c('template',{slot:"message"},[_vm._v("\n    Du har blitt logget ut\n  ")]),_vm._v(" "),_c('template',{slot:"text"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.login($event)}}},[_vm._v("Logg inn igjen")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3f2f91e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/service/LoggedOut.vue
// module id = null
// module chunks = 